
export const FETCH_BILL_ENTRY_REPORTS_DATA_REQUEST = 'FETCH_BILL_ENTRY_REPORTS_DATA_REQUEST';
export const FETCH_BILL_ENTRY_REPORTS_DATA_SUCCESS = 'FETCH_BILL_ENTRY_REPORTS_DATA_SUCCESS';
export const FETCH_BILL_ENTRY_REPORTS_DATA_FAILURE = 'FETCH_BILL_ENTRY_REPORTS_DATA_FAILURE';

export const FETCH_BILL_ENTRY_REPORTS_STYLE_WISE_REQUEST = 'FETCH_BILL_ENTRY_REPORTS_STYLE_WISE_REQUEST';
export const FETCH_BILL_ENTRY_REPORTS_STYLE_WISE_SUCCESS = 'FETCH_BILL_ENTRY_REPORTS_STYLE_WISE_SUCCESS';
export const FETCH_BILL_ENTRY_REPORTS_STYLE_WISE_FAILURE = 'FETCH_BILL_ENTRY_REPORTS_STYLE_WISE_FAILURE';

export const FETCH_BILL_ENTRY_REPORTS_SUPPLIER_WISE_REQUEST = 'FETCH_BILL_ENTRY_REPORTS_SUPPLIER_WISE_REQUEST';
export const FETCH_BILL_ENTRY_REPORTS_SUPPLIER_WISE_SUCCESS = 'FETCH_BILL_ENTRY_REPORTS_SUPPLIER_WISE_SUCCESS';
export const FETCH_BILL_ENTRY_REPORTS_SUPPLIER_WISE_FAILURE = 'FETCH_BILL_ENTRY_REPORTS_SUPPLIER_WISE_FAILURE';


export const FETCH_BILL_ENTRY_REPORT_DETAIL_REPORT_REQUEST = 'FETCH_BILL_ENTRY_REPORT_DETAIL_REPORT_REQUEST';
export const FETCH_BILL_ENTRY_REPORT_DETAIL_REPORT_SUCCESS = 'FETCH_BILL_ENTRY_REPORT_DETAIL_REPORT_SUCCESS';
export const FETCH_BILL_ENTRY_REPORT_DETAIL_REPORT_FAILURE = 'FETCH_BILL_ENTRY_REPORT_DETAIL_REPORT_FAILURE';

export const FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_REPORT_REQUEST = 'FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_REPORT_REQUEST';
export const FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_REPORT_SUCCESS = 'FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_REPORT_SUCCESS';
export const FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_REPORT_FAILURE = 'FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_REPORT_FAILURE';

export const FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_DETAIL_REPORT_REQUEST = 'FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_DETAIL_REPORT_REQUEST';
export const FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_DETAIL_REPORT_SUCCESS = 'FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_DETAIL_REPORT_SUCCESS';
export const FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_DETAIL_REPORT_FAILURE = 'FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_DETAIL_REPORT_FAILURE';

export const SET_SUMMARY_GRID_NAME_BILL_ENTRY_REPORT_DK = 'SET_SUMMARY_GRID_NAME_BILL_ENTRY_REPORT_DK';

export const FETCH_BILL_ENTRY_REPORTS_WITH_DEBIT_OR_CREDIT_REQUEST = 'FETCH_BILL_ENTRY_REPORTS_WITH_DEBIT_OR_CREDIT_REQUEST';
export const FETCH_BILL_ENTRY_REPORTS_WITH_DEBIT_OR_CREDIT_SUCCESS = 'FETCH_BILL_ENTRY_REPORTS_WITH_DEBIT_OR_CREDIT_SUCCESS';
export const FETCH_BILL_ENTRY_REPORTS_WITH_DEBIT_OR_CREDIT_FAILURE = 'FETCH_BILL_ENTRY_REPORTS_WITH_DEBIT_OR_CREDIT_FAILURE';